<template>
  <div v-if="showAdbox" class="floatBox" ref="floatBox" @mouseenter="enterbox" @mouseleave="leavebox">
    <a href="javascript:;" class="closeBox" @click="closeBox">
      <i class="el-icon-circle-close" style="font-size: 24px;" />
    </a>
    <div class="contentBody flexCloumnBetween">
      <div class="posLogo">
        <img style="height: 200%;margin-top: -10%;" :src="$store.state.config.applogo">
      </div>
      <div class="nameImg flexStart">
        <img style="height: 90%" :src="$store.state.config.leftlogo">
      </div>
      <div class="centerTitle flexCenter" @click="linkZph" style="color: #1890ff!important;">2024年校园招聘会</div>
      <div class="link flexEnd" @click="linkZph">点击前往<i class="el-icon-d-arrow-right"></i></div>

    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      x: 0,
      y: 0,
      xin: true,
      yin: true,
      step: 0.4,
      delay: 5,
      itl: null,
      showAdbox: true,
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.routeEnterShowAdbox()
    })
  },
  beforeRouteLeave(to, from, next) {
    next(vm => {
    })
    clearInterval(this.itl)
  },
  beforeDestroy() {
    clearInterval(this.itl)
  },

  mounted() {
    this.itl = setInterval(this.movebox, this.delay)
  },
  methods: {
    linkZph() {
      this.$router.push({
        path: '/xxzph',
      });
    },
    closeBox() {
      this.showAdbox = false
      clearInterval(this.itl)
    },
    leavebox() {
      if (this.showAdbox == false) {
        clearInterval(this.itl)
      } else {
        this.itl = setInterval(this.movebox, this.delay)
      }
    },
    enterbox() {
      clearInterval(this.itl)
    },
    movebox() {
      var L = 0
      var T = 0
      // var R = document.documentElement.clientWidth - this.$refs.floatBox.offsetWidth    //浏览器显示宽度-adbox宽度，不随滚动条变化而变化
      var B = document.documentElement.clientHeight - this.$refs.floatBox.offsetHeight  //浏览器显示高度-adbox高度，不随滚动条变化而变化
      // this.$refs.floatBox.style.left = this.x + document.documentElement.scrollLeft + 'px'  //adbox初始左+滚动条最左端到浏览器最左端的距离
      this.$refs.floatBox.style.top = this.y + document.documentElement.scrollTop + 'px'    //adbox初始高+滚动条顶端到浏览器顶端的距离
      console.log('this.$store.state.leftmenu:', this.$store.state.leftmenu)

      if (this.$store.state.leftmenu) {//未收起菜单栏
        var R = document.documentElement.clientWidth - this.$refs.floatBox.offsetWidth - 255    //浏览器显示宽度-adbox宽度，不随滚动条变化而变化
        this.$refs.floatBox.style.left = 255 + this.x + document.documentElement.scrollLeft + 'px'  //adbox初始左+滚动条最左端到浏览器最左端的距离
      }
      if (!this.$store.state.leftmenu) {//收起菜单栏
        var R = document.documentElement.clientWidth - this.$refs.floatBox.offsetWidth - 64   //浏览器显示宽度-adbox宽度，不随滚动条变化而变化
        this.$refs.floatBox.style.left = 64 + this.x + document.documentElement.scrollLeft + 'px'  //adbox初始左+滚动条最左端到浏览器最左端的距离
      }
      this.x = this.x + this.step * (this.xin ? 1 : -1)
      if (this.x < L) {
        this.xin = true
        this.x = L
      }
      if (this.x > R) {
        this.xin = false
        this.x = R
      }
      this.y = this.y + this.step * (this.yin ? 1 : -1)
      if (this.y < T) {
        this.yin = true
        this.y = T
      }
      if (this.y > B) {
        this.yin = false
        this.y = B
      }
    },
    routeEnterShowAdbox() {
      this.itl = setInterval(this.movebox, this.delay)
    }
  }
}
</script>
<style scoped lang="less" type="text/less">
.floatBox {
  width: 350px;
  height: 150px;
  position: absolute;
  z-index: 10;
  border: 3px solid #33a9ff;
  border-radius: 4px;
  background-color: transparent;
  padding: 6px;

  .closeBox {
    position: absolute;
    top: 10px;
    right: 11px;
    cursor: pointer;
    color: #fff;
    font-size: 16px;
    z-index: 99;
  }

  .contentBody {
    width: 100%;
    height: 100%;
    padding: 6px;
    background-image: linear-gradient(#33a9ff, #f0fbff);
    border-radius: 4px;
    position: relative;

    .posLogo {
      position: absolute;
      height: calc(100% - 12px);
      opacity: 0.06;
      overflow: hidden;
    }

    .nameImg {
      position: relative;
      z-index: 10;
      width: 100%;
      height: 30%;
    }

    .centerTitle {
      position: relative;
      z-index: 10;
      width: 100%;
      height: 45%;
      font-size: 22px;
      text-shadow: 0 0 5px #ffffff;
      font-weight: 700;
      cursor: pointer;
    }

    .link {
      position: relative;
      z-index: 10;
      width: 100%;
      height: 25%;
      color: #1890ff;
      font-weight: 700;
      cursor: pointer;
    }
  }
}
</style>
